"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = require("classnames");
var React = require("react");
var LTInfoViews_1 = require("components/newLTUI/LTInfoViews");
var LTImageTagViews_1 = require("components/newLTUI/LTImageTagViews");
var MobileImageViews_1 = require("components/newUI/Common/ImageViews/MobileImageViews");
var common_1 = require("services/page/common");
var url_1 = require("utils/url");
var constants_1 = require("mobile/routes/constants");
var smartimagesrc_1 = require("@ezbuy/smartimagesrc");
var styles = require("./index.scss");
var LTMProductsCard = (function (_super) {
    __extends(LTMProductsCard, _super);
    function LTMProductsCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.productClick = function (url) {
            var _a = _this.props, index = _a.index, position = _a.position;
            var link = url_1.genPrmLink(url, { floor: index, position: position });
            window.location.href = link;
        };
        return _this;
    }
    LTMProductsCard.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, productElement = _b.productElement, layout = _b.layout, ui = _b.ui;
        if (!productElement || !layout) {
            return null;
        }
        var img = productElement.img, name = productElement.name, extra = productElement.extra, originPrice = productElement.originPrice, url = productElement.url;
        var price = productElement.price;
        var rightTopTag, leftTopTag, titleIcons, collect, columnNum, interaction, imgH;
        if (extra) {
            rightTopTag = extra.tag && extra.tag.img;
            titleIcons = extra.titleIcons && extra.titleIcons[0] && extra.titleIcons[0].icon;
            collect = extra.rightView && extra.rightView.text;
            leftTopTag = extra.discountInfo && extra.discountInfo.imgUrl;
        }
        if (layout) {
            columnNum = layout.columnNum;
            interaction = layout.interaction;
        }
        if (ui) {
            imgH = ui.shape && constants_1.ProductShape[ui.shape];
        }
        var singleCard = (React.createElement("div", { className: styles.LTSingleCardWrap, onClick: function () { return _this.productClick(url); } },
            React.createElement("div", { className: styles.imgWrap },
                React.createElement(MobileImageViews_1.MobileImageViews, { isPostImageToBackground: true, src: smartimagesrc_1.makeImageUrls(img, {
                        online: true
                    })[0], style: {
                        maxWidth: "100%",
                        maxHeight: "100%"
                    }, isLazyLoad: true, params: "imageView2/2/w/200", alisize: 2 }),
                React.createElement(LTImageTagViews_1.LTImageTagViews, __assign({ columnNum: 1 }, { leftTopTag: leftTopTag, rightTopTag: rightTopTag }))),
            React.createElement(LTInfoViews_1.LTInfoViews, { columnNum: 1, price: Number(price), originalPrice: Number(originPrice), name: name, titleIcons: titleIcons, collect: collect, interaction: interaction })));
        var doubleCard = (React.createElement("div", { className: classnames_1.default(styles.LTDoubleCardWrap, (_a = {},
                _a[styles.roll] = interaction === common_1.ModuleInteraction.RollOver,
                _a[styles.LTRoll] = interaction === common_1.ModuleInteraction.RollOver,
                _a)), onClick: function () { return _this.productClick(url); } },
            React.createElement("div", { className: styles.imgWrap, style: { height: layout.interaction === common_1.ModuleInteraction.RollOver ? "9.375rem" : imgH } },
                React.createElement(MobileImageViews_1.MobileImageViews, { isPostImageToBackground: true, src: smartimagesrc_1.makeImageUrls(img, {
                        online: true
                    })[0], isLazyLoad: true, style: {
                        maxWidth: "100%",
                        maxHeight: "100%",
                        borderTopLeftRadius: "4px",
                        borderTopRightRadius: "4px"
                    }, params: "imageView2/2/w/300", alisize: 2 }),
                React.createElement(LTImageTagViews_1.LTImageTagViews, { columnNum: 2, rightTopTag: rightTopTag, leftTopTag: leftTopTag, leftBottomTag: titleIcons })),
            React.createElement(LTInfoViews_1.LTInfoViews, { columnNum: 2, price: Number(price), originalPrice: Number(originPrice), name: name, titleIcons: titleIcons, collect: collect, interaction: interaction })));
        var tripleCard = (React.createElement("div", { className: classnames_1.default(styles.tripleCardWrap), onClick: function () { return _this.productClick(url); } },
            React.createElement(MobileImageViews_1.MobileImageViews, { isPostImageToBackground: true, src: smartimagesrc_1.makeImageUrls(img, {
                    online: true
                })[0], style: {
                    maxWidth: "100%",
                    maxHeight: "100%"
                }, isLazyLoad: true, params: "imageView2/2/w/200", alisize: 2 }),
            React.createElement(LTInfoViews_1.LTInfoViews, { columnNum: 3, price: Number(price), originalPrice: Number(originPrice), name: name, titleIcons: titleIcons, collect: collect, interaction: interaction })));
        if (columnNum === 1) {
            return singleCard;
        }
        if (columnNum === 2) {
            return doubleCard;
        }
        if (columnNum === 3) {
            return tripleCard;
        }
        return null;
    };
    return LTMProductsCard;
}(React.Component));
exports.default = LTMProductsCard;
